import React, { Component } from "react";
import Swiper from "react-id-swiper";

class TestimonialSlider extends Component {
  render() {
    const params = {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      effect: "fade",
      autoplay: {
        delay: 3000
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      },
      renderPagenation: () => <div className="swiper-pagination"></div>
    };
    let data = [
      {
        testimonialImage: "1.jpg",
        testimonialName: "Devender Kumar",
        testimonialDesignation: "Founder",
        testimonialText:
          "We believe every child deserves love, support, education, and equal opportunities to grow. Our mission is to create an inclusive environment where children with special needs can learn, develop confidence, and achieve their full potential."
      },
      {
        testimonialImage: "2.jpg",
        testimonialName: "Himanshu Yadav",
        testimonialDesignation: "Director",
        testimonialText:
          "Working at Shakuntla Learn and Fly Foundation has taught us that every child is unique and full of potential. Seeing their growth, confidence, and smiles after consistent support and care inspires us to continue this mission with dedication and compassion every single day."
      },
      {
        testimonialImage: "3.jpg",
        testimonialName: "Deepak Kumar",
        testimonialDesignation: "Academic coordinator",
        testimonialText:
          "Our team believes that with the right guidance, patience, and opportunities, every child can learn, grow, and achieve meaningful progress. We are proud to be part of a journey that brings hope, positivity, and a better future to so many families."
      }
    ];

    let DataList = data.map((val, i) => {
      return (
        <div className="swiper-slide testimonial-slider__single-slide" key={i}>
          <div className="author">
            <div className="author__image">
              <img
                src={`assets/img/testimonial/${val.testimonialImage}`}
                alt=""
              />
            </div>
            <div className="author__details">
              <h4 className="name">{val.testimonialName}</h4>
              <div className="designation">{val.testimonialDesignation}</div>
            </div>
          </div>
          <div className="content">{val.testimonialText}</div>
        </div>
      );
    });

    return (
      <div>
        {/*====================  testimonial slider area ====================*/}
        <div
          className="testimonial-slider-area testimonial-slider-area-bg section-space--inner--120"
          style={{
            backgroundImage: `url(assets/img/backgrounds/testimonial.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-10 offset-lg-1">
                <div className="testimonial-slider">
                  <div className="testimonial-slider__container-area">
                    <Swiper {...params}>{DataList}</Swiper>
                    <div className="swiper-pagination"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of testimonial slider area  ====================*/}
      </div>
    );
  }
}

export default TestimonialSlider;
